import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { isMobile } from 'react-device-detect'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
// import MapUpperBar from '../component/map/MapUpperBar'
import MapUpperBarCustom from '../component/map/MapUpperBarCustom'
import MapIdentifyResult from '../component/map/MapStationDetail'
import Snackbar from '../control/Snackbar'
import Drawer from '../control/Drawer'
import DialogControl from '../control/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Dialog from '@mui/material/Dialog'
import MapToolLayer from '../component/map/MapToolLayer'
import MapToolIdentify from '../component/map/MapToolIdentify'
import MapResultToggleWeb from '../component/map/MapResultToggleWeb'
import MapResultToggleMobile from '../component/map/MapResultToggleMobile'
import ContentSearchGuide from '../component/map/ContentSearchGuide'
import ContentWelcome from '../component/map/ContentWelcome'
import CoreMenu from '../component/map/CoreMenu'
import useMap from '../hooks/map/useMap'
import useSnackbarStore from '../stores/useSnackbarStore'
import withDialog, { CallBackOpenDialog } from '../control/dialogAlert/withDialog'

const BgMenuImage = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/bg_menu.png`
type MapProps = CallBackOpenDialog
let Map: FC<MapProps> = (props) => {
    const mapHook = useMap({ ...props })
    const { t } = useTranslation()
    const classes = useStyles()
    const snackbarStore = useSnackbarStore()

    return (
        <>
            <div className={classes.root} ref={mapHook.refElementMap}></div>
            <div ref={mapHook.refComponentTopLeft}>
                <MapUpperBarCustom
                    onClickHamburger={mapHook.onOpenDrawer}
                    onClickInfo={mapHook.onOpenDialogSearchGuide}
                    showDialog={mapHook.showDialog}
                    searchStationByLatLon={mapHook.searchStationByLatLon}
                    drawStationFromSearchKeyword={mapHook.drawStationFromSearchKeyword}
                />
            </div>
            <div ref={mapHook.refComponentTopRight}>
                <MapToolIdentify disabled={mapHook.isDisabledMaptool} onClick={mapHook.onClickSearchByLatLonTool} />
                <MapToolLayer
                    isCheckPinLayer={mapHook.visiblePinLayer}
                    isCheckCoverageAreaLayer={mapHook.visibleCoverageAreaLayer}
                    isCheckAntennaPatternLayer={mapHook.visibleAntennaPatternLayer}
                    onCheckPinLayer={mapHook.onCheckPinLayer}
                    onCheckCoverageAreaLayer={mapHook.onCheckCoverageAreaLayer}
                    onCheckAntennaPatternLayer={mapHook.onCheckAntennaPattern}
                />
            </div>
            <div ref={mapHook.refComponentBottomScreenWeb} onClick={() => mapHook.onClickMapResult()}>
                <MapResultToggleWeb
                    data={mapHook.searchData}
                    disabledCurrentLocation={mapHook.isDisabledMaptool}
                    expanded={mapHook.expandedResult}
                    onClickResult={mapHook.onClickStationResult}
                    onClickShowExpand={mapHook.onClickShowResult}
                    onClickHideExpand={mapHook.onClickHideResult}
                    onBaseMapSelected={mapHook.onBaseMapSelected}
                    onClickRotation={mapHook.onClickRotation}
                    onClickCurrentLocation={mapHook.onClickCurrentLocation}
                    onClickZoomIn={mapHook.onClickZoomIn}
                    onClickZoomOut={mapHook.onClickZoomOut}
                    resetSearchData={mapHook.resetSearchData}
                />
            </div>
            <div ref={mapHook.refComponentBottomScreenMobile}>
                <MapResultToggleMobile
                    data={mapHook.searchData}
                    disabledCurrentLocation={mapHook.isDisabledMaptool}
                    expanded={mapHook.expandedResult}
                    onClickResult={mapHook.onClickStationResult}
                    onClickShowExpand={mapHook.onClickShowResult}
                    onClickHideExpand={mapHook.onClickHideResult}
                    onBaseMapSelected={mapHook.onBaseMapSelected}
                    onClickRotation={mapHook.onClickRotation}
                    onClickCurrentLocation={mapHook.onClickCurrentLocation}
                    resetSearchData={mapHook.resetSearchData}
                />
            </div>
            <Drawer
                isOpen={mapHook.openDrawer}
                onClose={mapHook.onCloseDrawer}
                onClickBackdrop={mapHook.onClickDrawerDim}
                overrideClass={{ paper: classes.drawerPaper }}
            >
                <CoreMenu
                    menuList={mapHook.menuList}
                    onCloseDrawer={mapHook.onCloseDrawer}
                    onClickMenuItem={mapHook.onClickMenuItem}
                />
            </Drawer>
            <DialogControl
                isOpen={mapHook.openDialogSearchGuide}
                onClose={mapHook.onCloseDialogSearchGuide}
                title={t('ALERT.TITLE.SEARCH_GUIDANCE')}
            >
                <ContentSearchGuide />
            </DialogControl>

            <Dialog fullWidth={true} maxWidth="md" open={mapHook.openDialogWelcome}>
                <DialogContent style={{ padding: '0px' }}>
                    <ContentWelcome
                        onClickAccept={mapHook.onClickAcceptDialogWelcome}
                        data={mapHook.dataTermsAndConditions}
                    />
                </DialogContent>
            </Dialog>
            <DialogControl
                type="ok"
                title={t('ALERT.TITLE.NOTIFY')}
                content={t('LABEL.MAP.MAP_LOCATION_BLOCK')}
                isOpen={mapHook.openDialogLocationBlock}
                onClickOk={mapHook.onClickCloseDialogLocationBlock}
                labelButtonOk={t('BUTTON.OK')}
                disableClickBackdrop
                hideCloseButton
            />

            <MapIdentifyResult
                onClose={mapHook.onClosePopupIdentifyResult}
                isOpen={mapHook.openPopupIdentifyResult}
                data={mapHook.identifyData}
                dataContact={mapHook.dataContact}
            />
            <Snackbar
                isOpen={mapHook.openSnackbar}
                onClose={mapHook.onCloseSnackbar}
                message={`กรุณา${isMobile ? 'แตะ' : 'คลิก'}บนแผนที่เพื่อระบุตำแหน่งจุดรับ`}
                autoHide={false}
                disableClickOutside
            />
            <Snackbar
                type="error"
                message={'Session expired'}
                isOpen={snackbarStore.isOpen}
                autoHideDuration={snackbarStore.openDuration}
                onClose={() => snackbarStore.setOpenSnackbar(false)}
                position={{ vertical: 'bottom', horizontal: 'left' }}
            />
        </>
    )
}
Map = observer(Map)
Map = withDialog(Map)
export default Map

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    drawerPaper: {
        backgroundImage: theme.palette.getContrastText('gradient'),
        //backgroundImage: `url(${BgMenuImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
    },
}))
